import { render } from "./PacienteCita01.vue?vue&type=template&id=08a9c58b"
import script from "./PacienteCita01.vue?vue&type=script&lang=js"
export * from "./PacienteCita01.vue?vue&type=script&lang=js"

import "./PacienteCita01.vue?vue&type=style&index=0&id=08a9c58b&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__